import DragIndicatorOutlinedIcon from '@mui/icons-material/DragIndicatorOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import * as React from 'react';
import { useDrag, useDrop } from 'react-dnd';

import DeleteIconButton from '../components/DeleteIconButton';
import RemoteAutocomplete from '../components/RemoteAutocomplete';

const DND_NEARBY = "dnd_nearby";

const useStyles = makeStyles(theme => ({
    root: {},
    dragHandle: {
        "&:hover": {
            cursor: "pointer"
        }
    },
    dragPreview: {
        background: '#e6f2ff',
        border: '1px solid #b3d7ff',
        borderRadius: '5px',
    }
}));

const ActivityRecommendedNearbyEditor = (props) => {
    const dndref = React.useRef(null);
    const classes = useStyles();

    const onActivitySelect = (ev, a) => {
        props.onChange && props.onChange({ activity: a.id, name: a.name }, props.idx);
    }
    const onDelete = () => {
        props.onDelete && props.onDelete(props.idx);        
    }

    // eslint-disable-next-line no-unused-vars
    const [{ handlerId }, drop] = useDrop({
        accept: DND_NEARBY,
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            };
        },
        hover: (item, monitor) => {
            // console.log('hover', dragPreview.current);
            if (!dndref.current) { return; }
            // console.log('hover', item);
            const dragIndex = item.idx;
            const hoverIndex = props.idx;
            if (dragIndex === hoverIndex) { return; }
            // console.log('hover', dragIndex, 'over', hoverIndex);
            const hoverBoundingRect = dndref.current?.getBoundingClientRect();
            // Get vertical middle
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            // Determine mouse position
            const clientOffset = monitor.getClientOffset();
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) { return; }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) { return; }

            if (props.swapItems) {
                // console.log('swapping', dragIndex, hoverIndex);
                props.swapItems(dragIndex, hoverIndex);
                item.idx = hoverIndex;
            }
        },
        drop: (item, monitor) => {
            // console.log('drop -> save order', props);
            // props.saveOrder && props.saveOrder();
        }

    });

    const [collected, drag, dragPreview] = useDrag({
        type: DND_NEARBY,
        item: () => {
            console.log('item', props.data.id, props.idx);
            return { id: props.data.id, idx: props.idx };
        },
        collect: (monitor, a) => {
            // console.log('collect', monitor.getItem());
            return {
                isDragging: monitor.isDragging(),
            }
        },
        end: (item, monitor) => {
            // console.log('end of drag -> save order', props);
            // props.saveOrder && props.saveOrder();
        }
    });
    // const opacity = collected.isDragging ? 0.5 : 1;

    drag(drop(dndref));

    // console.log('ActivityOntripNearby', props);

    return (<div ref={drop} className={clsx(collected.isDragging && classes.dragPreview)}>
        <Grid container direction="row" spacing={2} ref={dragPreview}>
            <Grid item xs={1} container alignItems="center" justifyContent="center">
                <div ref={dndref} className={classes.dragHandle}><DragIndicatorOutlinedIcon/></div>
            </Grid>
            <Grid item xs={7} sm={9} container alignItems="center">
                <RemoteAutocomplete
                    getOptionLabel={opt => (opt.name || "")}
                    resource="activity"
                    urlSuffix={null}
                    label="Activity"
                    variant="filled"
                    size="small"
                    fullWidth
                    onChange={onActivitySelect}
                    value={props.data}
                    disabled={props.disabled}
                />
            </Grid>
            <Grid item xs={2} sm={1} container alignItems="center" > <Button color="primary" href={`/activity/${props.data.activity}`} target="_blank" title="Open activity in new tab"><OpenInNewIcon /></Button></Grid>
            <Grid item xs={2} sm={1} container alignItems="center"><DeleteIconButton disabled={props.disabled} onClick={onDelete} /></Grid>
        </Grid>
    </div>);
}

export default ActivityRecommendedNearbyEditor;
